import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatThreadCreated.meta';

export type UseTrackAgentChatThreadCreatedParams = {
  canvas_id: string;
  thread_id: string;
};

export const useTrackAgentChatThreadCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatThreadCreated = useCallback(
    (params: UseTrackAgentChatThreadCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatThreadCreated };
};
